import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

export const pairingSuccessSecondaryBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.PAIR,
  eventName: EVENT_NAMES.PAIRING_SUCCESS_SECONDARY,
  pairingCode: action.meta.pairingCode,
});
